import src from "IMAGE";
export default { src, width: 298, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AK+0tbOIi4yJSEhIRlFRUU9ZWVlYV1dXV0xMTEpQUFBPAKanqKd3eHh3QEBAPUREREFISEhGQUFBP0JCQkBHR0dEV7cXQ4hX+fUAAAAASUVORK5CYII="};
